export function hasDoctorPrefix(value) {
  return /^dr\.?\s+/i.test(String(value || "").trim());
}

export function formatDoctorName(value, fallback = "Doctor") {
  const raw = typeof value === "object" && value !== null
    ? (value.display_name || value.doctor_name || value.full_name || value.name || value.email)
    : value;
  const name = String(raw || "").trim();
  if (!name) return fallback;
  if (/^(unassigned|not assigned|unnamed|doctor|—|-)$/.test(name.toLowerCase())) return fallback;
  if (hasDoctorPrefix(name)) return name.replace(/^dr\.?\s+/i, "Dr. ");
  return `Dr. ${name}`;
}
